import React, { useState, useEffect } from 'react';
import AddressProofContainer from '../AddressProofContainer/AddressProofContainer';
import Passport from '../PassportComp/Passport';
import VoterID from '../UserVoterCard/UserVoterDetails';
import { useFormikContext } from 'formik';
import ResidentialStatus from '../../ResidentialAddress/ResidentialStatus';
import BankStament from '../BankDetails/BankStament';
import BankPassbook from '../BankDetails/BankPassbook';
import DlComp from '../DlComp/DlComp';
import UtilityBillContainer from '../AddressProofContainer/UtilityBillContainer';
import Lpg from '../Lpg/Lpg';
import UserHRLetter from '../UserHRLetter/UserHRLetter';
import PngGas from '../UtilityBillPNG/PngGas';
import UserElectricityBill from '../UserElectricityBill/UserElectricityBill';
import { UserKycSave } from '../../../../common/constants/api';
import PopUp from '../../../../common/components/PopUp/PopUp';
import { getApplicantionInfo } from '../../../../common/utils/applicantionInfo';

const AddressProofFlow = () => {
  const {
    values,
    data,
    setData,
    handleChange,
    errors,
    touched,
    handleBlur,
    setFieldError,
    setFieldValue,
    name,
    setFileUploadErrors,
    fileUploadErrors,
    setFieldTouched,
    handleSubmit,
    formikProps,
    status,
    albusProps
  } = useFormikContext();
  console.log('fjrjeigor', formikProps, status, albusProps);
  const [Selected, setSelected] = useState(false);
  const [shoAddressDetails, setAddressDetails] = useState(false);
  const [SelectedUtilityBill, setSelectedUtilityBill] = useState(false);
  const [AddressSelectionBox, showAddressSelectionBox] = useState(false);
  const [popUpType, setPopUpType] = useState('loading');
  const [popUpText, setPopUpText] = useState('');
  const [show, setShow] = useState(false);
  const [leadId, setLeadId] = useState(getApplicantionInfo().leadId);
  const [applicantId, setApplicantId] = useState(
    getApplicantionInfo().leadApplicantId
  );

  const CustomhandleSubmit = () => {
    setAddressDetails(true);
  };
  useEffect(() => {
     if (values.isValid() == 'yes') {
      setFieldValue('isAddressProofNeed',false)
      handleSubmit();

    }
  }, []);

  const handlePropertyType = async () => {
    await setPopUpType('loading');
    await setPopUpText('loading please wait!');
    setShow(true);
    let body = {
      isOwned: values.PropertyType == 'owned' ? true : false,
      ownedBy: values.PropertyType == 'owned' ? values.OwnedBy : '',
      rentPerMonth: values.PropertyType == 'owned' ? 0 : values.monthlyRent,
      ////added new
      name: {
        firstName: values.firstName,
        middleName: values.middleName,
        lastName: values.lastName
      },
      relation: values?.relationShip?.value
    };

    UserKycSave(leadId, applicantId, body, 'residency')
      .then(res => {
        if (res.error) {
          throw new Error(res.error.data.message);
        }
        setShow(false);
        handleSubmit();
      })
      .catch(async err => {
        await setPopUpType('fail');
        await setPopUpText(err.toString());
        setShow(true);
      });
  };

  useEffect(() => {
    let docName = localStorage.hasOwnProperty('loadComponent')
      ? localStorage.getItem('loadComponent')
      : false;

    if (docName) {
      if (docName == 'bank_passbook') setSelected('Bank Passbook');
      else if (docName == 'bank_statement') setSelected('Bank Statement');
      else if (docName == 'voter_id') setSelected('Voter ID');
      else if (docName == 'passport') setSelected('Passport');
      else if (docName == 'driving_license') setSelected('Driving License');
      else if (docName == 'hr_letter') setSelected('HR Letter');
      else if (docName == 'lpg') {
        setSelected('Utility Bill');
        setSelectedUtilityBill('LPG');
      } else if (docName == 'png') {
        setSelected('Utility Bill');
        setSelectedUtilityBill('PNG');
      } else if (docName == 'ebill') {
        setSelected('Utility Bill');
        setSelectedUtilityBill('Electricity Bill');
      }
      localStorage.hasOwnProperty('loadComponent')
        ? localStorage.removeItem('loadComponent')
        : false;
    }
  }, []);

  useEffect(() => {
    if (Selected != 'Utility Bill') {
      setSelectedUtilityBill(false);
    }
  }, [Selected]);
  return (
    <div className="w-full ">
      {!shoAddressDetails && values.isValid() != 'yes' ? (
        <>
          <div className="mr-auto md:ml-5 ">
            {!Selected ||
            AddressSelectionBox ||
            (Selected == 'Utility Bill' && !SelectedUtilityBill) ? (
              <>
                <AddressProofContainer
                  setSelected={setSelected}
                  cardShow={false}
                />
              </>
            ) : (
              <div className="w-full text-right py-3">
                <p
                  className="font-roboto font-medium  text-sm ml-auto text-green-1000 cursor-pointer "
                  onClick={() => showAddressSelectionBox(true)}
                >
                  Change Address Proof
                </p>
              </div>
            )}
          </div>
          {Selected == 'Passport' ? (
            <Passport handleSubmit={CustomhandleSubmit} />
          ) : null}
          {Selected == 'Voter ID' ? (
            <VoterID handleSubmit={CustomhandleSubmit} />
          ) : null}
          {Selected == 'Driving License' ? (
            <DlComp handleSubmit={CustomhandleSubmit} />
          ) : null}

          {Selected == 'Bank Statement' ? (
            <BankStament handleSubmit={CustomhandleSubmit} />
          ) : null}
          {Selected == 'Bank Passbook' ? (
            <BankPassbook handleSubmit={CustomhandleSubmit} />
          ) : null}

          {Selected == 'Utility Bill' ? (
            <UtilityBillContainer
              setSelectedUtilityBill={setSelectedUtilityBill}
            />
          ) : null}

          {Selected == 'Utility Bill' && SelectedUtilityBill == 'LPG' ? (
            <Lpg handleSubmit={CustomhandleSubmit} />
          ) : null}

          {Selected == 'Utility Bill' && SelectedUtilityBill == 'PNG' ? (
            <PngGas handleSubmit={CustomhandleSubmit} />
          ) : null}

          {Selected == 'Utility Bill' &&
          SelectedUtilityBill == 'Electricity Bill' ? (
            <UserElectricityBill handleSubmit={CustomhandleSubmit} />
          ) : null}

          {Selected == 'HR Letter' ? (
            <UserHRLetter handleSubmit={CustomhandleSubmit} />
          ) : null}
        </>
      ) : (
        <>
          <ResidentialStatus
            values={values}
            data={data}
            handleChange={handleChange}
            errors={errors}
            touched={touched}
            handleBlur={handleBlur}
            setFieldError={setFieldError}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
          />
          <button
            type="button"
            onClick={handlePropertyType}
            className={
              ' submitButton text-14 w-56 h-12 font-medium  font-roboto'
            }
          >
            Save & Verify
          </button>
        </>
      )}
      <PopUp type={popUpType} text={popUpText} setShow={setShow} show={show} />
    </div>
  );
};

export default AddressProofFlow;
